import type { WishlistResponse } from '~/types/on24-klient'
import { useQuery } from '@tanstack/vue-query'
import { usePageQuery } from './shared'

const query = () => {
  const app = useNuxtApp()

  return useQuery({
    queryKey: ['wishlist-page'],
    queryFn: async () => {
      return await app.$api<WishlistResponse>('/account/wishlist')
    },
  })
}

export const useWishlistPageQuery = usePageQuery(query)
